module.exports = __webpack_public_path__ + "static/media/sweden-flag-round-small.b452d5de.png";